/**
 * Route constants for the application.
 * Centralized route definitions for consistency.
 */

export const ROUTES = {
  HOME: '/',
  CART: '/cart',
  ACCOUNT: '/account',
  ORDERS: '/account/orders',
  ADDRESSES: '/account/addresses',
  PROFILE: '/account/profile',
  HELP: '/help',
  CHAT: '/help/chat',
  TERMS: '/account/terms',
  PRIVACY: '/account/privacy',
  ORDER_TRACKING: '/account/orders/:orderId',
};

/**
 * Generate a dynamic route path.
 */
export function orderTrackingPath(orderId) {
  return `/account/orders/${orderId}`;
}

/**
 * Check if current path matches a route pattern.
 */
export function matchesRoute(pathname, route) {
  if (route.includes(':')) {
    const pattern = route.replace(/:[^/]+/g, '[^/]+');
    return new RegExp(`^${pattern}$`).test(pathname);
  }
  return pathname === route;
}
